var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-wrap"},[_c('div',{staticClass:"copyright"},[_vm._v("Copyright ©2018-©2019 enterprise-admin finance web")])])
}]

export { render, staticRenderFns }